import { graphqlClient } from '@/api/graphqlClient';
import App from '@/App';
import { MotionLazy } from '@/components/animate/motion-lazy';
import store from '@/store/store';
import { ApolloProvider } from '@apollo/client';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';

import reportWebVitals from './reportWebVitals';
import { themeConfig, ThemeProvider } from './theme';

const container = document.getElementById('root');

if (!container) {
  throw new Error(
    "Root container not found. Make sure the element with id 'root' exists in your HTML."
  );
}

const rootElement = createRoot(container);

rootElement.render(
  <StrictMode>
    <ApolloProvider client={graphqlClient}>
      <Provider store={store}>
        <ThemeProvider
          modeStorageKey={themeConfig.modeStorageKey}
          defaultMode={themeConfig.enableSystemMode ? 'system' : themeConfig.defaultMode}>
          <MotionLazy>
            <App />
          </MotionLazy>
        </ThemeProvider>
      </Provider>
    </ApolloProvider>
  </StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
if (process.env.NODE_ENV !== 'production') {
  reportWebVitals(console.log);
}
